<template>
  <div class="w-100" :class="{ submittedClass: submitted }">
    <div class="card shadow overflow-hidden border-top-0 rounded-top-0 p-0 mx-0" :class="{ hide: submitted }">
      <form class="w-100" method="post" novalidate="true" @submit.prevent="submit">
        <div class="card-body px-4 py-4">
          <div class="form-group row flex-column">
            <label class="col font-PM text-gray mb-3" for="currentValue">Ingresá el valor de la propiedad</label>
            <div class="col">
              <div class="content-element bg-white border border-borders rounded-lg overflow-hidden">
                <div class="element-form-ico w-100 text-primary d-flex align-items-stretch">
                  <div class="bg-light d-flex justify-content-center align-items-center p-2">
                    <h2 class="font-PM text-nowrap px-1 px-sm-2 mb-0">US$</h2>
                  </div>
                  <input v-model="form.valor" type="number"
                    class="form-control h-auto form-control-lg border-0 text-primary text-left font-AR"
                    id="currentValue" name="currentValue" placeholder="300.000" maxlength="8" required>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group row flex-column flex-sm-row no-gutters justify-content-between align-items-center border border-borders rounded p-3">
            <label class="col col-xl-7 font-PM text-gray pr-0 pr-sm-4 my-2 my-sm-1">¿Es tu única propiedad en
              CABA?</label>
            <div class="content-element bg-transparent wrapper-btn-drop p-1 my-2 my-sm-1">
              <div class="row no-gutters justify-content-center align-items-center" @click="toggleEnCaba">
                <div class="col-6 order-1">
                  <a :class="{ selected: form.enCaba === false }"
                    class="btn btn-text btn-sm font-R text-nowrap active-circle-button-left text-gray text-uppercase w-100 px-2 py-0 mb-0">no
                  </a>
                </div>
                <div class="col-6 order-2">
                  <a :class="{ selected: form.enCaba === true }"
                    class="btn btn-text btn-sm font-R text-nowrap active-circle-button-right text-gray text-uppercase w-100 px-2 py-0 mb-0">si</a>
                </div>
                <div
                  class="btn-drop btn btn-left rounded-pill bg-light border border-borders order-3 position-absolute py-0">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer bg-transparent border-0 px-4 pt-2 pt-md-4 pb-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-12">
              <div class="row no-gutters justify-content-end">
                <button type="submit" name="submit" :disabled="!isFormFilled"
                  class="btn btn-outline-primary rounded-pill cta-start mb-4 text-uppercase font-ARB btn-square">
                  Ver resultado
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-lg-12 mb-4 mb-xl-5" v-if="submitted">
      <div class="row">
        <div class="col-md-12 card rounded-top-0 shadow overflow-hidden mx-0 py-3 mb-4">
          <div class="row no-gutters justify-content-center align-items-center bg-primary rounded py-5">
            <div class="col-md-9 text-center py-4 py-xl-5">
              <img src="/images/icons/percentage.svg" class="mb-4" alt="resultado">
              <div class="result">
                <div class="element-form-ico w-100 d-flex justify-content-center align-items-center text-white">
                  <h2 class="font-PM text-nowrap text-center mb-0">$ <span class="font-PB" id="cont-resultado">{{
                    numeral(result).format('0,000.00') }}</span></h2>
                </div>
              </div>
              <p class="font-PM text-white mb-4 pb-3">Gasto total para el comprador</p>
              <div>
                <button type="button" @click="reset"
                  class="btn btn-secondary rounded-pill btn-square text-uppercase font-ARB">Volver a
                  calcular
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <p class="small font-R text-gray"><b>Aclaración:</b> El cálculo es estimativo y contempla aportes notariales,
            inscripción del título, certificados, estudios de
            títulos entre otros gastos fijos. No están considerados los honorarios del escribano que paga el comprador y
            rondan
            el 2% del valor en el que se escritura-. En el caso del vendedor: si es persona física y reemplaza vivienda,
            para
            obtener la exención del ITI (1,5%) debe tramitar el certificado de no retención. La calculadora considera
            sólo las
            escrituras que se realizan en la Capital Federal y entre personas humanas – no jurídicas –. En la Provincia
            de Buenos
            Aires, por ejemplo, el impuesto a los sellos es menor y además hay gastos de agrimensura que paga el
            vendedor de
            la propiedad, entre otras diferencias.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import numeral from 'numeral';

export default {
  props: ['dolar'],
  setup(props) {
    const form = ref({
      masDe3millones: false,
      enCaba: false,
      valor: null
    });

    const errors = ref({});
    const submitted = ref(false);
    const result = ref(null);
    const isFormFilled = computed(() => {
      return form.value.valor !== null &&
        form.value.masDe3millones !== null &&
        form.value.valor !== null &&
        form.value.enCaba !== null;
    });
    const validateForm = () => {
      let valid = true;
      errors.value = {};

      if (!form.value.valor) {
        errors.value.valor = 'Este campo es requerido';
        valid = false;
      } else if (isNaN(form.value.valor) || form.value.valor < 0 || form.value.valor > 999999) {
        errors.value.valor = 'Debe ser un número entre 0 y 999999';
        valid = false;
      }

      return valid;
    };

    const toggleEnCaba = () => {
      form.value.enCaba = !form.value.enCaba;
    };

    const submit = () => {
      if (validateForm()) {
        const value = form.value.valor * props.dolar;

        const escritura = (0.005 + 0.00125) * value;

        let sello;
        if (!form.value.enCaba) {
          sello = 0.018 * value;
        } else {
          if (value >= 3500000) {
            sello = 0.018 * (value - 3500000);
          } else {
            sello = 0;
          }
        }
        result.value = sello + escritura;

        submitted.value = true;
      } else {
        console.log('Formulario no válido');
      }
    };

    const reset = () => {
      submitted.value = false;
      form.value = {
        masDe3millones: false,
        enCaba: false,
        valor: null
      };
      errors.value = {};
    };

    const isFormValid = computed(() => validateForm());

    return {
      form,
      errors,
      submitted,
      result,
      toggleEnCaba,
      submit,
      reset,
      isFormValid,
      numeral,
      isFormFilled
    };
  }
};
</script>

<style lang="scss">
a {
  cursor: pointer;
}

.submittedClass {
  position: absolute;
  height: 705px;
  top: -58px;
  z-index: 5;
}
</style>
